<template>
  <div>
    <mdb-side-nav-2
      v-model="show"
      :data="navigation"
      color="white"
      over
      :sidenav-class="['grey', 'darken-3']"
    >
      <div slot="header" class="mt-1">
        <div class="p-3 pt-5">
            <img
              src="../assets/Quadrus Logo grayscale.png"
              class="img-fluid"
            />
        </div>
        <hr />
        <ul class="list-unstyled">
          <mdb-row class="d-flex justify-content-center">
            <mdb-col>
            <li class="mb-2 imgZoom">
              <a href="https://www.facebook.com/QuadrusCorporation/" target="_blank" class="px-3 icons-sm gplus-ic">
                <mdb-icon class="facebook" color="white" fab icon="facebook" size="2x" />
              </a>
            </li>
            <li class="imgZoom">
              <a href="https://www.linkedin.com/company/quadrus-corporation/mycompany/" target="_blank" class="px-3 icons-sm tw-ic">
                <mdb-icon class="linkedin" color="white" fab icon="linkedin" size="2x" />
              </a>
            </li>
            </mdb-col>
            <mdb-col>
            <li class="mb-2 imgZoom">
              <a href="https://quadruscorp.com" target="_blank">
                <img class="logo logo-white" src="../assets/Quadrus Logo wht.png" style="max-height: 2.5em;">
                <!--<img class="logo logo-color" src="../assets/Quadrus Logo color.png" style="max-height: 2.5em;">-->
              </a>
            </li>
            <li class="imgZoom">
              <a href="https://quadruscorp.bamboohr.com/" target="_blank">
                <img class="logo logo-white" src="../assets/BambooHR.png" style="max-height: 1.1em;">
                <!--<img class="logo logo-color" src="../assets/BambooHR.png" style="max-height: 1.1em;">-->
              </a>
            </li>
            </mdb-col>
          </mdb-row>
          <!--<mdb-row class="m-4 d-flex justify-content-center">
            <li class="imgZoom">
              <a href=" https://sftp.quadruscorp.com" target="_blank" style="color: white !important;">
                 <mdb-icon color="white" fas icon="fas fa-lock" />Secure File Transfer
              </a>
            </li>
          </mdb-row>-->
        </ul>
        <hr />

      </div>

      <mdb-navbar
        slot="nav"
        tag="div"
        position="top"
        dark
        :toggler="false"
        :style="{ zIndex: '10', backgroundColor: 'black'}"
      >

          <mdb-navbar-nav left>
            <div class="align-items-center">
              <mdb-icon
                icon="bars"
                class="white-text"
                size="lg"
                @click.native="show = !show"
                :style="{cursor: 'pointer'}"
              />
              <router-link to="/"><img class="pl-3" src="../assets/Quadrus Logo color reverse no bkgrd.png" height="30" alt="placeholder picture"></router-link>

            </div>
          </mdb-navbar-nav>
          
          <mdb-avatar class="mr-2">
            <img class="rounded-circle img-fluid" :src="$store.getters.getAvatar" height="70" width="70" alt="placeholder picture">
          </mdb-avatar>   
                    
          <mdb-dropdown>
            <mdb-dropdown-toggle slot="toggle" class="notification">
              <i class="fa fa-bell" style="font-size:40px; color:white"></i>
              <span v-if="this.notifications.length > 0" class="badge">{{ this.notifications.length }}</span>
            </mdb-dropdown-toggle>
            <mdb-dropdown-menu class="dropdowDiv" v-if="this.notifications.length > 0">
              <div v-for="message in notifications" :key="message.id">
                <mdb-dropdown-item style="white-space: wrap !important;" v-on:click="goToMessage(message)">{{ message.details }}</mdb-dropdown-item>
                <div class="dropdown-divider"></div>
              </div>
            </mdb-dropdown-menu>
          </mdb-dropdown>     
          
          <mdb-dropdown>
            <mdb-dropdown-toggle slot="toggle" style="color: #000000; background-color: #FFFFFF">{{ username }}</mdb-dropdown-toggle>
            <mdb-dropdown-menu>
              <mdb-dropdown-item><router-link to="/My-Account">My Account</router-link></mdb-dropdown-item>
              <div class="dropdown-divider"></div>
              <mdb-dropdown-item @click="logout">Logout</mdb-dropdown-item>
            </mdb-dropdown-menu>
          </mdb-dropdown>
      </mdb-navbar>


    </mdb-side-nav-2>
  </div>
</template>
<style>
.dropdowDiv{
  max-height: 300px !important;
  overflow: auto;
  width: 300px;
}
.notification{
  width: 90% !important;
}
.badge {
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 5px 10px;
  border-radius: 50%;
  background: red;
  color: white;
}
/*.imgZoom:hover{
  transform: scale(1.3);
}
.facebook:hover{
  color: #3b5998 !important;
}
.linkedin:hover{
  color: #0077b5 !important;
}

.logo-color {
  display: none;
}
.imgZoom:hover .logo-white {
  display: none;
}
.imgZoom:hover .logo-color {
  display: block;
  margin: auto;
}*/
</style>
<script>

  //import Verify from '../../public/js/verify.js';

  import * as DatabaseLib from '@/assets/js/DatabaseLib.js';

  import {
    mdbNavbar,
    mdbNavbarNav,
    mdbSideNav2,
    mdbIcon,
    mdbResize,
    mdbDropdown, 
    mdbDropdownItem, 
    mdbDropdownMenu, 
    mdbDropdownToggle,
    mdbAvatar,
    mdbCol,
    mdbRow
  } from "mdbvue";

  export default {
    name: "DoubleNavigationPagev1",
    components: {
      mdbNavbar,
      mdbNavbarNav,
      mdbSideNav2,
      mdbIcon,
      mdbDropdown,
      mdbDropdownItem,
      mdbDropdownMenu,
      mdbDropdownToggle,
      mdbAvatar,
      mdbCol,
      mdbRow
    },
    data() {
      return {
        show: false,
        over: false,
        username: "",
        isInItCcb: false,
        timeoutInMS: 3600000, // 1 hour -> 60 * 60 * 1000
        timeoutId: 0,
        notifications: [],
      };
    },
    methods: {
      async loadMessages(){
        //Search notification table to see if user has any unread messages
        let token = this.$store.getters.getToken;
        this.notifications = [];
        let query = "filters[username][$eq][0]="+ this.$store.getters.getUser + "&filters[notified][$eq][1]="+ false;
        let response = await DatabaseLib.getRequest('strapiDatabase','notifications',token,query);
        for(var i = 0; i < response.data.data.length; i++){
          this.notifications.push({
            id: response.data.data[i].id,
            details: response.data.data[i].attributes.details,
            type: response.data.data[i].attributes.type,
            closeOnClick: response.data.data[i].attributes.closeOnClick
          })
        }
      },

      async getITCCB(){
        let token = this.$store.getters.getToken;
        let query = "filters[username][$eq][0]="+ this.$store.getters.getUser;
        let response = await DatabaseLib.getRequest('strapiDatabase','itcr-ccb-members',token,query);
        if(response.data.data.length > 0){
          this.isInItCcb = true;
        } 
      },

      async goToMessage(msg){
        let token = this.$store.getters.getToken;
        if(msg.type == "Ticket Status" && this.$route.name != "TicketStatus"){
          if(msg.closeOnClick == true){
            await DatabaseLib.deleteRequest('strapiDatabase','notifications',token,msg.id);
            this.loadMessages();
          }
          this.$router.push({
            name: 'TicketStatus',
          })
        } else if(msg.type == "QPR" && this.$route.name != "ReviewQPR"){
          this.$router.push({
            name: 'ReviewQPR',
          })
        } else if(msg.type == "Manage Ticket" && this.$route.name != "SupportTicket"){
          this.$router.push({
            name: 'SupportTicket',
          })
        } else if(msg.type.includes("QCR") && this.$route.name != "ViewQCR"){
          this.$router.push({
            name: 'ViewQCR',
          })
        } else if(msg.type == "Manage Projects" && this.$route.name != "ManageProjects"){
          this.$router.push({
            name: 'ManageProjects',
          })
        } else if(msg.type == "ITCR Audit" && this.$route.name != "auditITCR"){
          if(this.$store.getters.getGroups.includes("CM") || this.$store.getters.getGroups.includes("Administration")){  
            this.$router.push({
              name: 'auditITCR'
            })
          } else {
            this.$router.push({
              name: 'ITCR'
            })
          }
        } else if(msg.type == "ITCR" && this.$route.name != "ITCR"){
          this.$router.push({
            name: 'ITCR',
          })
        } 
      },

      checkWidth() {
        this.over = window.innerWidth < 900;
      },
      logout: function () {
        this.$store.dispatch('logout')
        .then(() => {
          if(this.$route.name !=='Login'){
            this.$router.push({ name: 'Login' });
          }
        })
      },
      startTimer: function() { 
        this.timeoutId = setTimeout(this.logout, this.timeoutInMS);
      },
      resetTimer: function() {
        clearTimeout(this.timeoutId);
        if(this.$route.name !== 'Login' && this.$route.name !== "SMSTextingPolicy"){
          this.startTimer();
        }
      },
      setupTimers: function () {
        if(this.$route.name !=='Login' && this.$route.name !== "SMSTextingPolicy"){
          document.addEventListener("keypress", this.resetTimer, false);
          document.addEventListener("mousemove", this.resetTimer, false);
          document.addEventListener("mousedown", this.resetTimer, false);
          document.addEventListener("touchmove", this.resetTimer, false);
          this.startTimer();
        }
      },

      getUsername: function() { this.username = this.$store.getters.getUser;}
    },
    directives: {
      mdbResize
    },

    computed: {
      navigation() {
        let navigationArray = [];

        
        navigationArray.push(
          {
            name: "Home",
            icon: "home",
            to: "/"
          }
        );
        
        if (this.$store.getters.getGroups.includes("Administration"))
        {
          navigationArray.push(
            {
              name: "Administration",
              icon: "toolbox",
              children: [
                {
                  name: "Manage Contract Data",
                  to: "/ManageContractData"
                },
                {
                  name: "Visitor Log",
                  to: "/Visitor-Log"
                },
                {
                  name: "Audit IT Change Requests",
                  to: "/auditITCR"
                }
              ]
            }
          );
          /*navigationArray.push(
            {
              name: "Administrator Tools",
              icon: "clipboard-list",
              children: [
                {
                  name: "WAR Submission Status",
                  to: "/Administrator-Tools/WARSubmissionStatus"
                }
              ]
            },
          );*/
        }

        if(this.$store.getters.getGroups.includes("CM") && !this.$store.getters.getGroups.includes("Administration")){
          navigationArray.push(
            {
              name: "Administration",
              icon: "toolbox",
              children: [
                {
                  name: "Audit IT Change Requests",
                  to: "/auditITCR"
                }
              ]
            }
          );
        }

        if (this.$store.getters.getGroups.includes("Marketing"))
        {
          navigationArray.push(
            {
              name: "Marketing",
              icon: "bullhorn",
              children: [
                {
                  name: "Edit Home Page",
                  to: "/Edit-Homepage"
                }
              ]
            }
          );
        }

        if (this.$store.getters.getGroups.includes("Employee"))
        {
          navigationArray.push(
            {
              name: "WAR Reports",
              icon: "file-alt",
              children: [
                {
                  name: "Create New Report",
                  to: "/WAR-Reports/Create-New-Report"
                },
                {
                  name: "View Submitted Reports",
                  to: "/WAR-Reports/View-Submitted-Reports"
                },
                {
                  name: "Edit Saved Reports",
                  to: "/WAR-Reports/Edit-Saved-Reports"
                },
                {
                  name: "View Monthly Report",
                  to: "/WAR-Reports/View-Monthly-Report"
                }
              ]
            },
            {
              name: "Project Overview",
              icon: "map",
              children: [
                {
                  name: "QPR Form",
                  to: "/Project-Overview/QPR-Form"
                },
                {
                  name: "View Submited QPR",
                  to: "/Project-Overview/View-QPR"
                },
              ]
            },
            {
              name: "IT Support",
              icon: "hammer",
              children: [
                {
                  name: "Submit a Support Ticket",
                  to: "/IT/SubmitSupportTicket",
                },
                {
                  name: "Ticket Status",
                  to: "/IT/TicketStatus",
                }
              ]
            },
          )
        }

        /*
        navigationArray.push(
          {
            name: "Operations",
            icon: "cogs",
            children: [
              {
                name: "Create QPR",
                to: "/New-QPR"
              },
              {
                name: "View QPR",
                to: "/View-QPR"
              }
            ]
          }
        );
        */

        /*
        navigationArray.push(
          {
            name: "Corp. Development",
            icon: "road",
            children: [
              {
                name: "Manage",
                to: "/Corp-Dev-Manage"
              },
              {
                name: "View",
                to: "/Corp-Dev-View"
              },
              {
                name: "Monthly Report",
                to: "/Corp-Dev-Monthly-Report"
              },
              {
              name: "Yearly Report",
              to: "/Corp-Dev-Yearly-Report"
              }
            ]
          }
        );
        */

        /*
        navigationArray.push(
          {
            name: "Training",
            icon: "graduation-cap",
            to: "/Training"
          }
        );
        */

        if (this.$store.getters.getGroups.includes("Employee"))
        {
          navigationArray.push(
            {
              name: "Resources",
              icon: "book-open",
              children: [
                {
                  name: "Employee Directory",
                  to: "/Resources/Employee-Directory"
                }
              ]
            }
          );
        }
        
        if(this.$store.getters.getGroups.includes("IT")) {
          navigationArray.find(element => element.name == "IT Support").children.push(
            {
              name: "Manage Support Tickets",
              to: "/IT/ManageSupportTicket"
            },
            {
              name: "Asset Tracking",
              to: "/IT/AssetTracking"
            },
            {
              name: "Create New User",
              to: "/Create-New-User"
            },
            {
              name: "View/Edit Users",
              to: "/View-Edit-User-Page"
            },
            {
              name: "Submit ITCR",
              to: "/IT/ITCR-Form"
            },
            /*,
            {
              name: "Reset Password",
              to: "/IT/ResetUserPassword"
            }*/
          )
        }

        if(this.$store.getters.getGroups.includes("CM") || this.$store.getters.getGroups.includes("IT")||
          (this.$store.getters.getGroups.includes("CCB") && this.isInItCcb)){ 
          navigationArray.find(element => element.name == "IT Support").children.push(
            {
              name: "View ITCR",
              to: "/IT/ITCR"
            },
          )
        }

        if(this.$store.getters.getRole == "Administrator" ||
          this.$store.getters.getGroups.includes("CM")|| 
          this.$store.getters.getGroups.includes("Project Manager") ||
          this.$store.getters.getGroups.includes("Developer")) {
          navigationArray.find(element => element.name == "Project Overview").children.push(
            {
              name: "Review QPR",
              to: "/Project-Overview/Review-QPR"
            },  
          )
        }
        if(this.$store.getters.getRole == "Administrator" ||
          (this.$store.getters.getGroups.includes("CCB") && JSON.parse(this.$store.getters.getCCBGroups).length > 0) ||
          this.$store.getters.getGroups.includes("CM")||
          this.$store.getters.getGroups.includes("Project Manager")){
          navigationArray.find(element => element.name == "Project Overview").children.push(  
            {
              name: "Pending QCR",
              to: "/Project-Overview/Pending-QCR"
            },  

          )
        }
       
        if(this.$store.getters.getRole == "Administrator" ||
          this.$store.getters.getGroups.includes("CM")|| 
          (this.$store.getters.getGroups.includes("CCB") && JSON.parse(this.$store.getters.getCCBGroups).length > 0) ||
          this.$store.getters.getGroups.includes("Project Manager") ||
          this.$store.getters.getGroups.includes("Developer")) {
          navigationArray.find(element => element.name == "Project Overview").children.push(  
            {
              name: "Review QCR",
              to: "/Project-Overview/Review-QCR"
            },
            {
              name: "Review Products",
              to: "/Project-Overview/Review-Products"
            },
          )
        }

      
        /*if(this.$store.getters.getGroups.includes("Supervisor")) {
          navigationArray.push(
            {
              name: "Supervisor Tools",
              icon: "magic",
              children: [
                {
                  name: "Timestamp Report",
                  to: "/Supervisor-Tools/TimestampReport"
                }
              ]
            },
          );*/
        
        return navigationArray;
      }
    },
    watch: {
      $route() {
        this.show = false
      }
    },
    beforeMount() {
      this.setupTimers()
    },
    mounted() {
      this.getUsername();
      this.getITCCB();
      this.loadMessages();
      this.bus.$on('fireMethod', () => {
        this.loadMessages();
      })
    }
  };
</script>
